import React from "react";
import PolicyPage from "./PolicyPage";
import { policies } from "../Datas/policyData";

function Cookies() {
  return <PolicyPage policy={policies.cookies} />;
}

export default Cookies;
